<template>
  <div class="app-container">
    <CrudTable
      entity="HemaPendingProject"
      :allow-create="false"
      :allow-edit="false"
      :allow-delete="true"
      :columns="columns"
      :custom-actions="getCustomListActions()"
      :on-row-dbl-click="() => {}"
    />
  </div>
</template>

<script>
import CrudTable from '@/components/crud/CrudTable';

export default {
  components: {
    CrudTable
  },
  data() {
    return {
      customActions: [{ handleClick: this.handleClick, buttonTranslation: 'test' }],
      columns: [
        { field: 'id', label: 'common.id', filter: { type: 'none' }, sortable: false },
        { field: 'prjNumber', label: 'hemaPendingProject.prjNumber', filter: { type: 'none' }, sortable: false },
        {
          field: 'prjDate',
          label: 'hemaPendingProject.prjDate',
          type: 'date',
          filter: { type: 'none' },
          sortable: false
        },
        {
          field: 'sentDate',
          label: 'hemaPendingProject.sentDate',
          type: 'date',
          filter: { type: 'none' },
          sortable: false
        },
        { field: 'customerName', label: 'hemaPendingProject.customerName', filter: { type: 'none' }, sortable: false },
        {
          field: 'customerDebtorCode',
          label: 'hemaPendingProject.customerDebtorCode',
          filter: { type: 'none' },
          sortable: false
        },
        {
          field: 'customerDeliveryCode',
          label: 'hemaPendingProject.customerDeliveryCode',
          filter: { type: 'none' },
          sortable: false
        }
      ]
    };
  },
  methods: {
    getCustomListActions() {
      return [
        {
          type: 'primary',
          icon: 'el-icon-plus',
          handleClick: this.handleAddClick,
          inRow: true
        },
        {
          type: 'primary',
          icon: 'el-icon-download',
          handleClick: this.handleDownloadClick,
          inRow: true
        }
      ];
    },
    handleAddClick(row) {
      this.$store.dispatch('hemaPendingProject/processPendingProject', { id: row.id }).then(() => {
        this.$store.dispatch('notify/success', { message: this.$i18n.t('common.order_processed') });
      });
    },
    handleDownloadClick(row) {
      // From https://stackoverflow.com/questions/19721439/download-json-object-as-a-file-from-browser
      this.$store.dispatch('hemaPendingProject/downloadProjectJson', { projectID: row.id }).then(blob => {
        const exportName = row.prjNumber ? row.prjNumber : `${row.id}`;
        const dataStr = 'data:text/json;charset=utf-8,' + encodeURIComponent(JSON.stringify(blob));
        const downloadAnchorNode = document.createElement('a');
        downloadAnchorNode.setAttribute('href', dataStr);
        downloadAnchorNode.setAttribute('download', exportName + '.json');
        document.body.appendChild(downloadAnchorNode); // required for firefox
        downloadAnchorNode.click();
        downloadAnchorNode.remove();
      });
    }
  }
};
</script>

<style scoped></style>
